import { ICoords } from "../../redux/modules/flightMarkers/flightMarkersReducer";
import { EpsgCode } from "../../constants/epsgCode";
import { ISRS } from "../../apiFacades/csu/site";
import { getProj4 } from "./getProj4";

export const convertWgs84ToGlobalCoords = (wgs84Coords: ICoords, srs: ISRS) => {
  const globalProjection = srs.isAssumed
    ? srs.assumedSrs.intermediateSrsProj4
    : srs.globalSrs.proj4;

  return getProj4()(EpsgCode.Wgs84, globalProjection, { ...wgs84Coords });
};
